<template>
  <div class="module-afiliasi">
    <SOSlotBase
      :container-name="'afiliated-page-content'"
      :bg-grey="true"
      :loading="isFetching && !isLoadMore"
      :is-search="onSearch"
    >
      <template v-slot:title-bar>
        <div>
          <SOTitleBar
            :page-title="'Teman Yang Bergabung'"
            :type="'back'"
            :show-search="true"
            @search="onOpenSearch"
            v-if="!onSearch"
            @back="back"
          />
        </div>
      </template>
      <template v-slot:search-bar>
        <SOSearchBar
          v-if="onSearch"
          :context="'Anda bisa mencari:'"
          :placeholder="`Ketik minimal 2 karakter`"
          :value="searchKey"
          :data-count="countData"
          :search-information="`Nama, nomor telepon, dan email`"
          :waiting="searching"
          @do-search="doSearch"
          @loading="onLoadingSearch"
          @close="onCloseSearch"
        />
      </template>
      <template v-slot:loading-page>
        <div>
          <SOLoadingPage />
        </div>
      </template>
      <template v-slot:empty-state>
        <div>
          <SOEmptyState
            v-if="!isFetching && afiliated.length < 1 && !onSearch"
            :message="'Belum ada teman bergabung'"
            :subMessage="'Teman yang mengaktifkan outlet dengan link referral anda akan tampil di sini'"
            :btn-action="true"
            @action="doCopyLink"
          />
          <SOEmptySearchState
            v-if="afiliated.length < 1 && !isFetching && onSearch && searchKey"
            @action="resetSearchFilter"
          />
        </div>
      </template>
      <template v-slot:content>
        <div class="p-x-20">
          <div v-if="!isFetching || isLoadMore">
            <div class="card_breadcrum p-t-16" v-if="totalOutlet > 0">
              <SOHeaderList
                :title="`${totalOutlet} Outlet Aktif`"
                :show-filter="true"
                @filter="togleFilter(true)"
              />
              <div class="sub-header f-c-midgrey f-regular f-12">
                Dari {{ totalAfiliated }} Teman Bergabung
              </div>
            </div>
            <div>
              <SOCardAfiliated
                :card-type="`shadow`"
                :data-afiliated="afiliated"
              />
            </div>
          </div>
          <SOLoadMoreLoading
            :id="'load-more-afiliated'"
            :loading="isLoadMore"
          />
        </div>
      </template>
      <template v-slot:filter>
        <SOFilter
          v-if="onFilter"
          :owner-afiliated="getJenisOwner"
          @back="togleFilter(false)"
          @do-filter="doFilter"
          @reset-filter="resetFilter"
        />
      </template>
    </SOSlotBase>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOFilter from "@/so-components/global/filter/base/SOFilter";

import SOCardAfiliated from "../components/SOCardAfiliated.vue";

import { moduleName } from "../store/state";
import jenisOwner from "../static/jenisOwner";

export default {
  name: "AfiliatedPage",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOHeaderList,
    SOCardAfiliated,
    SOLoadMoreLoading,
    SOLoadingPage,
    SOEmptyState,
    SOSearchBar,
    SOEmptySearchState,
    SOFilter,
  },
  data() {
    return {
      onSearch: false,
      onFilter: false,
      searching: false,
      searchKey: "",
    };
  },
  mounted() {
    this.init();
    this.scroll();
  },
  watch: {
    response: function (newRes, oldRes) {
      this.onLoadingSearch(false);
      if (!newRes.success) {
        if (newRes.err && newRes.err !== oldRes.err) {
          this.$toast.error(newRes.err);
        }
      }
    },
  },
  computed: {
    ...mapGetters(moduleName, {
      afiliated: "afiliated",
      afiliatedTotal: "afiliatedTotal",
      afiliasiSet: "afiliasiSet",
      response: "getResponse",
      isFetching: "isFecthing",
      isLoadMore: "isLoadMore",
      pagination: "pagination",
    }),
    totalAfiliated() {
      return this.afiliasiSet.afiliated.totalTeman;
    },
    totalOutlet() {
      return this.afiliasiSet.afiliated.totalOutlet;
    },
    referalLink() {
      return this.afiliasiSet.referalLink;
    },
    countData() {
      return this.afiliated.length;
    },
    getJenisOwner() {
      return jenisOwner;
    },
  },
  methods: {
    ...mapActions({
      getDataAfiliated: `${moduleName}/getDataAfiliated`,
      getListAfiliated: `${moduleName}/getListAfiliated`,
      resetPagination: `${moduleName}/resetPagination`,
      resetAfiliated: `${moduleName}/resetAfiliated`,
      resetCountData: `${moduleName}/resetCountData`,
    }),
    back() {
      this.$router.push({ name: "afiliasi.dashboard" });
      this.resetDataList();
    },
    resetDataList() {
      this.resetAfiliated();
      this.resetCountData();
    },
    async init() {
      await this.resetPagination();
      await this.resetDataList();
      await this.resetSearchKey();
      await this.loadData(this.searchKey);
      if (!this.totalAfiliated) {
        await this.getDataAfiliated();
      }
    },
    toggleSearch(val) {
      this.onSearch = val;
    },
    togleFilter(val) {
      this.onFilter = val;
    },
    loadData(searchKey) {
      this.getListAfiliated(searchKey);
    },
    async scroll() {
      window.onscroll = async () => {
        if (!this.response.success) {
          return;
        }

        let payload = {
          idLoadMore: "load-more-afiliated",
          container: "afiliated-page-content",
          pagination: this.pagination,
          callback: this.loadData,
        };

        await this.$store.dispatch("helper/scroll", payload);
      };
    },
    doCopyLink() {
      var TempText = document.createElement("input");
      TempText.value = this.referalLink;
      document.body.appendChild(TempText);
      TempText.select();

      try {
        let successful = document.execCommand("copy");
        let msg = successful ? "successful" : "unsuccessful";
        this.$toast.success(msg);
      } catch (e) {
        this.$toast.error(e);
      }

      document.body.removeChild(TempText);
    },
    setSearchKey(val) {
      this.searchKey = val;
    },
    onOpenSearch() {
      this.toggleSearch(true);
      this.resetSearchFilter();
      this.resetDataList();
    },
    onCloseSearch() {
      this.toggleSearch(false);
      this.resetSearchFilter();
      this.init();
    },
    onLoadingSearch(value) {
      this.searching = value;
    },
    async doSearch(searchKey) {
      await this.resetPagination();
      await this.resetDataList();
      await this.setSearchKey(searchKey);
      await this.loadData(searchKey);
    },
    async doFilter() {
      await this.resetPagination();
      await this.resetDataList();
      await this.togleFilter(false);
      await this.loadData(this.searchKey);
    },
    async resetFilter() {
      await this.$store.commit("filterGlobalModule/resetFilterItem");
    },
    resetSearchKey() {
      this.searchKey = "";
    },
    resetSearchFilter() {
      this.resetFilter();
      this.resetSearchKey();
    },
  },
};
</script>
<style scoped>
.sub-header {
  margin-top: -20px;
  margin-bottom: 16px;
}
</style>
